import "./Item.css";
import { ItemDetailsData } from "../../../../Utils/DefinitionsInterfaces";
import { TrashIcon } from "../../../../Assets/svgs";
import { formatExamDate } from "../../../../Utils/dateFormatter";
import usePricing from "../../../../Utils/hooks/usePricing";

interface ItemPropsInterface {
  stateCheckoutItems: ItemDetailsData[];
  isDefaultItem: boolean;
  cbRemoveProduct: (itemId: number) => void;
}

const MultipleItems = (props: ItemPropsInterface) => {
  const { cartPricing, formatPrice } = usePricing("cod");
  console.log(props.stateCheckoutItems);

  // Helper function to determine if remove button should be shown
  const shouldShowRemoveButton = (itemId: number) => {
    const itemCount = props.stateCheckoutItems.length;
    const hasItem1 = props.stateCheckoutItems.some((item) => item.id === 1);
    const hasItem2 = props.stateCheckoutItems.some((item) => item.id === 2);
    const hasItem3 = props.stateCheckoutItems.some((item) => item.id === 3);

    // If all three items are present, show remove for all
    if (itemCount === 3) return true;

    // If only one item, show remove button
    if (itemCount === 1) return true;

    // If two items and one is item 3, show remove for item 3 only
    if (itemCount === 2 && hasItem3) {
      return itemId === 3;
    }

    // If items 1 and 2 only, show remove for both
    if (itemCount === 2 && hasItem1 && hasItem2) {
      return true;
    }

    return false;
  };

  const RoundComponent = () => {
    return (
      <div
        style={{
          height: "10px",
          width: "10px",
          backgroundColor: "rgba(154, 200, 254, 0.3)",
          border: "2px",
          borderColor: "rgba(35, 81, 136, 1)",
          borderRadius: 100,
          marginLeft: "10px",
          marginRight: "10px",
          marginTop: "10px",
        }}
      ></div>
    );
  };
  const priceLineStyle = {
    width: "60%",
    height: "2px",
    backgroundColor: "rgba(217, 217, 217, 1)",
    alignSelf: "center",
    marginRight: "10px",
  };
  const priceContainerStyle = {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  };

  const basePriceStyle = {
    textDecoration: "line-through",
    marginRight: "10px",
  };

  return (
    <div className="items">
      <div className="item">
        <div
          className="wrap"
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "normal",
          }}
        >
          {props.stateCheckoutItems.map((item, index) => {
            return (
              <div
                key={`multiple-item-${item.id}`}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    cursor: "pointer",
                  }}
                  className="item-title"
                >
                  {item.name}

                  {shouldShowRemoveButton(item.id) && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        fontSize: "16px",
                        alignItems: "center",
                        gap: "5px",
                        color: "rgba(2, 59, 143, 1)",
                      }}
                      onClick={() => {
                        props.cbRemoveProduct(item.id);
                      }}
                    >
                      Remove
                      <img
                        style={{
                          width: "18px",
                          height: "18px",
                        }}
                        src={TrashIcon}
                        alt="Trash Icon"
                      />
                    </div>
                  )}
                </div>

                <div style={priceContainerStyle}>
                  <div style={priceLineStyle}></div>
                  <div>
                    <span style={basePriceStyle} className="text-wrapper-3">
                      {"₹" + item.base_price}
                    </span>
                    <span className="text-wrapper-3">
                      {formatPrice(
                        cartPricing.items.find((i) => i.itemId === item.id)
                          ?.displayPrice || 0
                      )}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="item-description">
        <div className="item">
          <div
            className="wrap"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div className="item-title">{"Total Price"}</div>
            <div style={priceContainerStyle}>
              <div style={priceLineStyle}></div>
              <div>
                <span style={basePriceStyle} className="text-wrapper-3">
                  {formatPrice(cartPricing.subtotal.basePrice)}
                </span>
                <span className="text-wrapper-3">
                  {formatPrice(cartPricing.subtotal.finalPrice)}
                </span>
              </div>
            </div>
          </div>
        </div>

        <br />
        <div className="item-details-breakdown">
          <RoundComponent />
          <div className="item-details-text">
            {props.stateCheckoutItems[0].description}
          </div>
        </div>
        <br />
        <div className="item-details-breakdown">
          <RoundComponent />
          <div className="item-details-text">
            A copy of the NFO Handbook will be delivered to the provided address
            within 7 to 8 business days.
          </div>
        </div>
        <br />
        {props.stateCheckoutItems.map((item, index) => {
          return (
            item.id === 3 && (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="item-details-breakdown">
                  <RoundComponent />
                  <div className="item-details-text">
                    Exam Scheduled for: {formatExamDate(item.examDate)}
                  </div>
                </div>
                <br />
                <div
                  style={{ borderBottom: 0 }}
                  className="item-details-breakdown"
                >
                  <RoundComponent />
                  <div className="item-details-text">
                    Exam Mode: Proctored Online (from your home)
                    <br />
                    Note: Access to the NFO Student Hub (for your student
                    credentials), will be sent to your registered mobile number
                    and email once payment is confirmed.
                  </div>
                </div>
              </div>
            )
          );
        })}
        <br />
      </div>
    </div>
  );
};

export default MultipleItems;
